﻿import { fieldsProxy } from "@serenity-is/corelib";
import { EmailQueuePriority } from "./EmailQueue.EmailQueuePriority";
import { EmailQueueStatus } from "./EmailQueue.EmailQueueStatus";

export interface EmailQueueRow {
    MailId?: number;
    Uid?: string;
    Subject?: string;
    Body?: string;
    SerializedMessage?: number[];
    MailFrom?: string;
    MailTo?: string;
    ReplyTo?: string;
    Cc?: string;
    Bcc?: string;
    Priority?: EmailQueuePriority;
    ErrorMessage?: string;
    Status?: EmailQueueStatus;
    RetryCount?: number;
    LockExpiration?: string;
    SentDate?: string;
    InsertUserId?: number;
    InsertDate?: string;
    InsertUser?: string;
}

export abstract class EmailQueueRow {
    static readonly idProperty = 'MailId';
    static readonly nameProperty = 'Subject';
    static readonly localTextPrefix = 'Pro.EmailQueue.EmailQueue';
    static readonly deletePermission = 'Administration:EmailQueue';
    static readonly insertPermission = 'Administration:EmailQueue';
    static readonly readPermission = 'Administration:EmailQueue';
    static readonly updatePermission = 'Administration:EmailQueue';

    static readonly Fields = fieldsProxy<EmailQueueRow>();
}